"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrl = void 0;
const DEFAULT_API_SEGMENT = ["logging", "v1"];
// Trim whitespace and remove any number of starting/ending slashes
const sanitize = (input) => {
    if (typeof input === "number")
        return input;
    return input?.trim().replace(/^\/+|\/+$/g, "");
};
const buildUrl = (apiUrl, segments) => {
    const parts = [apiUrl, ...DEFAULT_API_SEGMENT, ...segments];
    return new URL(parts.map(sanitize).join("/"));
};
exports.buildUrl = buildUrl;
